import * as mLatestNewsActions from '../actions/mLatestNewsActions';
import moment from 'moment';
import NewsItem from './NewsItem';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';
import {getLatestNewsViewAllHref} from '../utils/newsListFilters';


const PRODUCTS_PER_PAGE = 3;


class MLatestNews extends React.Component{
  state = {
    currentPage: 1,
  };


  componentDidMount(){
    //console.log(`MNews.componentDidMount()`, this.props);
    this.props.actions.initMLatestNews({
      program: this.props.program,
      relatedProgram: this.props.relatedProgram,
      relatedProject: this.props.relatedProject,
      relatedTag: this.props.relatedTag,
    }).then(results => {
      this.props.onLoad ? this.props.onLoad(results) : null;
    });
  }


  renderLink(){
    const url = getLatestNewsViewAllHref({
      program: this.props.program,
      relatedProject: this.props.relatedProject,
    });
    const label = this.props.viewAllLabel || (this.props.compact ? 'View all' : 'View All News');

    if(this.props.compact) return (
      <SuperLink to={url} className="m-latest-news__view-all-link">{label}</SuperLink>
    );
    if(this.props.horizontal) return (
      <center>
        <SuperLink to={url} className="m-latest-news__view-all tg-button tg-button--pill tg-button--black">
          <span className="tg-button__label">{label}</span>
        </SuperLink>
      </center>
    );
    else return (
      <div className="navigationlink navigationlink--blue-outline">
        <SuperLink to={url} className="navigationlink__link">
          <div className="navigationlink__title">{label}</div>
        </SuperLink>
      </div>
    );
  }
  renderNews(){
    if(!this.props.mLatestNews.news) return null;

    const news = this.props.mLatestNews.news.sort((a, b) => {
      return moment(b.newsDate).valueOf() - moment(a.newsDate).valueOf();
    }).slice(0, PRODUCTS_PER_PAGE);

    return news.map(event => {
      return (
        <div key={event.id}
             className="col-12 m-latest-news__listing-item-col">
          <NewsItem className="m-latest-news__news-item"
                    disableDate
                    disableDescription={!this.props.horizontal}
                    disableLocation
                    event={event}/>
        </div>
      );
    });
  }
  renderEmpty(){
    return (
      <div className="col-12">
        <p className="m-latest-news__empty">There is no news related to the project</p>
      </div>
    );
  }
  renderTitle(){
    let titleStr = 'LATEST NEWS';
    if(this.props.title)
      titleStr = this.props.title;
    else if(this.props.program && (this.props.program.Title || this.props.program.title))
      titleStr = `LATEST ${this.props.program.Title || this.props.program.title} NEWS`;

    const TitleTag = this.props.compact ? 'h2' : 'div';
    return (<TitleTag className="m-latest-news__title">{titleStr}</TitleTag>);
  }
  render(){
    // console.log(`MNews render`, this.props);
    const news = this.props.mLatestNews?.news;
    const hasNews = Array.isArray(news) && news.length > 0;
    const showEmptyRelatedProject =
      Boolean(this.props.relatedProject) &&
      Array.isArray(news) &&
      news.length < 1 &&
      !this.props.mLatestNews?.isLoading &&
      !this.props.hideWhenEmpty;

    if(!this.props.mLatestNews || (!hasNews && !showEmptyRelatedProject)) return null;

    const listing = (
      <React.Fragment>
        {this.props.compact ? (
          <div className="m-latest-news__header">
            {this.renderTitle()}
            {hasNews ? this.renderLink() : null}
          </div>
        ) : this.renderTitle()}
        <div className="m-latest-news__listing">
          <div className="row">{hasNews ? this.renderNews() : this.renderEmpty()}</div>
        </div>
        {hasNews && !this.props.compact ? this.renderLink() : null}
      </React.Fragment>
    );

    return (
      <div className={`m-latest-news ${this.props.compact ? 'm-latest-news--compact' : ''} ${this.props.className || ''}`}>
        {this.props.compact ? listing : (
          <div className="container container--coupling">
            {listing}
          </div>
        )}
      </div>
    );
  }
}


export default withRouter(connect(
  state => ({
    mLatestNews: state.mLatestNews,
  }),
  dispatch => ({
    actions: bindActionCreators(mLatestNewsActions, dispatch),
  }),
)(MLatestNews));


MLatestNews.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  compact: PropTypes.bool,
  hideWhenEmpty: PropTypes.bool,
  horizontal: PropTypes.bool,
  mLatestNews: PropTypes.object,
  onLoad: PropTypes.func,
  program: PropTypes.object,
  relatedProgram: PropTypes.object,
  relatedProject: PropTypes.object,
  relatedTag: PropTypes.object,
  title: PropTypes.string,
  viewAllLabel: PropTypes.string,
};
